import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

/**
 * Fetch all team members along with their payment subcollection if available.
 * @returns {Promise<Array>} - List of team members with payment details.
 */
export const getTeamMembers = async () => {
  try {
    // Reference to the 'users' collection
    const usersRef = collection(db, "users");

    // Query to find users with userType = 'team_member'
    const q = query(usersRef, where("userTypes", "==", "team_member"));

    // Execute the query
    const querySnapshot = await getDocs(q);

    // Process the results and fetch payment subcollection
    const teamMembers = await Promise.all(
      querySnapshot.docs.map(async (memberDoc) => {
        const memberData = { id: memberDoc.id, ...memberDoc.data() };

        // Reference to the 'payment' subcollection
        const paymentRef = collection(db, `users/${memberDoc.id}/payment`);
        const paymentSnapshot = await getDocs(paymentRef);

        // Check if the subcollection exists
        const payments = paymentSnapshot.empty
          ? [] // No payments found
          : paymentSnapshot.docs.map((paymentDoc) => ({
              paymentId: paymentDoc.id,
              ...paymentDoc.data(),
            }));

        return { ...memberData, payments }; // Attach payment details to the team member
      })
    );

    console.log(teamMembers);
    return teamMembers;
  } catch (error) {
    console.error("Error getting team members with payments:", error);
    return [];
  }
};
